export default function PaymentFailed() {
    return (
        <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", padding: 20 }}>
            <div style={{ background: "#fff", padding: 40, borderRadius: 20, boxShadow: "0 10px 30px rgba(0,0,0,0.1)", maxWidth: 500 }}>
                <h1 style={{ fontSize: 32, color: "#e53e3e", marginBottom: 20 }}>❌ Payment Failed</h1>
                <p style={{ fontSize: 18, color: "#555" }}>Your payment could not be processed. Please try again or contact support.</p>
                <a href="/" style={{ marginTop: 20, display: "inline-block", padding: "10px 20px", background: "#4f46e5", color: "#fff", borderRadius: 8 }}>Back to Registration</a>
            </div>
        </div>
    );
}
